import request from '@/utils/request'

export function getContacts(data) {
  return request({
    url:'/messageBoard/getContacts',
    method:'post',
    data:data
  })
}

export function getUnreadMsgCount() {
  return request({
    url:'/messageBoard/getUnreadMsgCount',
    method:'get',
  })
}

export function getMessagesByContactId(id) {
  return request({
    url:'/messageBoard/getMessagesByContactId/'+id,
    method:'get'
  })
}

export function getUnReadMessagesByContactId(id) {
  return request({
    url:'/messageBoard/getUnReadMessagesByContactId/'+id,
    method:'get'
  })
}

export function updateReadStatus(data) {
  return request({
    url:'/messageBoard/updUnReadStatus',
    method:'post',
    data:data
  })
}

export function sendMessage(data) {
  return request({
    url:'/messageBoard/sendAdminMessage',
    method:'post',
    data:data
  })
}








// WEBPACK FOOTER //
// ./src/api/messageBoard.js